import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * ErrorBoundary component catches React errors in child components
 * Displays error UI instead of blank screen on crash
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
    console.error('ErrorBoundary caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          backgroundColor: '#f5f5f5',
          padding: '20px',
        }}>
          <AlertCircle size={48} color="#dc3545" style={{ marginBottom: '20px' }} />
          <h1>Oops! Something went wrong</h1>
          <p style={{ color: '#666', marginBottom: '20px', maxWidth: '500px', textAlign: 'center' }}>
            An unexpected error occurred. Please refresh the page or contact support if the problem persists.
          </p>
          {process.env.NODE_ENV === 'development' && (
            <details style={{ marginTop: '20px', maxWidth: '800px', textAlign: 'left', backgroundColor: '#fff', padding: '15px', borderRadius: '4px' }}>
              <summary style={{ cursor: 'pointer', fontWeight: 'bold', color: '#dc3545' }}>Error Details (Development Only)</summary>
              <pre style={{ marginTop: '10px', overflow: 'auto', backgroundColor: '#f8f9fa', padding: '10px' }}>
                {this.state.error && this.state.error.toString()}
                {'\n\n'}
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
          <button
            onClick={() => window.location.href = '/'}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px',
            }}
          >
            Go Home
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
